export default __webpack_public_path__ + "static/images/4224176dc1dd65669e98154f15e48a23.png";